import {getPost} from 'mattermost-redux/selectors/entities/posts';
import type {Post} from 'mattermost-redux/types/posts';
import type {GlobalState} from 'types/store';

export const getThreadPostFollowState = (state: GlobalState, threadRootPostId: Post['id']) => {
    const post = getPost(state, threadRootPostId);

    return Boolean(post?.is_following);
};
